import { CTA } from '../@types/cta';
import { PartnerSectionData } from '../@types/partner';

export function getCTA(elem?: PartnerSectionData) {
  const cta: CTA = { label: 'LEARN MORE', target: '_self' };
  if (elem) {
    if (
      elem.__typename ===
      'WpPartner_Templatepartners_PartnerSection_Data_PdfFile'
    ) {
      cta.url = elem.mediaSelector?.localFile.publicURL;
    } else if (
      elem.__typename === 'WpPartner_Templatepartners_PartnerSection_Data_Url'
    ) {
      cta.url = elem.url;
      cta.pageSelector = elem.pageSelector;
      cta.target = elem.target || cta.target;
      cta.label = elem.label || cta.label;
    }
  }
  return cta;
}
